<template>
    <div>
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>询价列表</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <swb-price-inqry-search :no="no" @showPriceInqrySearch="priceInqrySearch"></swb-price-inqry-search>

        <div class="tab-container small base">
            <div class="tabs-nav">
                <ul class="head">
                    <li v-for="(text, value) in priceInqryStateList" :class="{'current': value == priceInqryStatus}" class="head-item" @click="tabChange(value)">
                        <span>{{text}}</span>
                    </li>
                </ul>
            </div>
        </div>
        <div>
            <table class="custom-tbl" v-if="priceInqryStatus==5">
                <thead class="head">
                <tr class="row">
                    <!--<th></th>-->
                    <th>询价单号</th>
                    <th width="">标题</th>
                    <th>被询价公司</th>
                    <th>询价类型</th>
                    <th>询价时间</th>
                    <th width="100">截止日期</th>
                    <th width="120" style="text-align: right">报价总金额(元)</th>
                    <th>有无采纳</th>
                    <th>操作</th>
                </tr>
                </thead>
                <tbody class="body">
                <tr class="row" v-for="priceInqryVoucher in priceInqryList">
                    <td>
                        <a class="swb-btn-link" @click="toPriceInpryInfo(priceInqryVoucher.id)">{{priceInqryVoucher.no}}</a>
                    </td>
                    <td style="text-align: left">{{priceInqryVoucher.title}}</td>
                    <td>{{priceInqryVoucher.peerMerchantName}}</td>
                    <td>{{priceInqryVoucher.tradeTypeName}}</td>
                    <td>{{priceInqryVoucher.publishTime}}</td>
                    <td>{{priceInqryVoucher.expireDate}}</td>
                    <td style="text-align: right">{{priceInqryVoucher.totalReplyPrice == null ? "" : (priceInqryVoucher.totalReplyPrice).toFixed(2)}}</td>
                    <td v-if="priceInqryVoucher.isHaveAdopted==true">有</td>
                    <td v-if="priceInqryVoucher.isHaveAdopted==false">无</td>
                    <td style="text-align: left">
                        <a class="swb-btn-link" v-if="checkActionPerm('view_reply')" @click="toPriceReplyList(priceInqryVoucher.id,priceInqryVoucher.expireDate)">查看报价</a>
                        <a class="swb-btn-link" v-if="checkActionPerm('view')" @click="toPriceInpryInfo(priceInqryVoucher.id)">查看</a>
                        <!--<a class="swb-btn-link" v-if="checkActionPerm('close') " @click="priceInpryClose(priceInqryVoucher.id)">关闭</a>-->
                        <a class="swb-btn-link" v-if="checkActionPerm('finish')" @click="priceInqryFinish(priceInqryVoucher.id)">结束</a>
                        <a class="swb-btn-link" v-if="checkActionPerm('setTag')" @click="setPriceInqryVoucherTag(priceInqryVoucher,priceInqryStatus)">设置标签</a>
                        <a class="swb-btn-link" v-if="checkActionPerm('sourceMgmt')" @click="showSourceTraceDlg(priceInqryVoucher)">来源管理</a>
                        <a class="swb-btn-link" v-if="checkActionPerm('cancelRelate') && priceInqryVoucher.srcFlag > 0" @click="cancelRelate(priceInqryVoucher.id)">取消来源</a>
                    </td>
                </tr>
                </tbody>
            </table>

            <table class="custom-tbl" v-if="priceInqryStatus==3">
                <thead class="head">
                <tr class="row">
                    <!--<th></th>-->
                    <th>询价单号</th>
                    <th width="">询价标题</th>
                    <th>被询价公司</th>
                    <th>询价类型</th>
                    <th>申请人</th>
                    <th>申请时间</th>
                    <th width="100">截止时间</th>
                    <th>有无采纳</th>
                    <th>审核人</th>
                    <th>审核意见</th>
                    <th>操作</th>
                </tr>
                </thead>
                <tbody class="body">
                <tr class="row" v-for="priceInqryVoucher in priceInqryList">
                    <td>
                        <a class="swb-btn-link" @click="toPriceInpryInfo(priceInqryVoucher.id)">{{priceInqryVoucher.no}}</a>
                    </td>
                    <td style="text-align: left">{{priceInqryVoucher.title}}</td>
                    <td>{{priceInqryVoucher.peerMerchantName}}</td>
                    <td>{{priceInqryVoucher.tradeTypeName}}</td>
                    <td>{{priceInqryVoucher.applicantName}}</td>
                    <td>{{priceInqryVoucher.applyTime}}</td>
                    <td>{{priceInqryVoucher.expireDate}}</td>
                    <td v-if="priceInqryVoucher.isHaveAdopted==true">有</td>
                    <td v-if="priceInqryVoucher.isHaveAdopted==false">无</td>
                    <td>{{priceInqryVoucher.auditorName}}</td>
                    <td>{{priceInqryVoucher.auditDesc}}</td>
                    <td style="text-align: left">
                        <a v-if="checkActionPerm('audit') && postId != priceInqryVoucher.creatorPostId && priceInqryVoucher.auditState ==0" class="swb-btn-link" @click="priceInpryAudit(priceInqryVoucher.id)">审核</a>
                        <a class="swb-btn-link" v-if="checkActionPerm('view')" @click="toPriceInpryInfo(priceInqryVoucher.id)">查看</a>
                        <a v-if="checkActionPerm('apply') && postId == priceInqryVoucher.creatorPostId" class="swb-btn-link" @click="priceInpryApply(priceInqryVoucher.id)">再次申请</a>
                        <a v-if="checkActionPerm('delete') && !priceInqryVoucher.published" class="swb-btn-link" @click="priceInpryDelete(priceInqryVoucher.id)">删除</a>
                        <a class="swb-btn-link" v-if="checkActionPerm('setTag')" @click="setPriceInqryVoucherTag(priceInqryVoucher,priceInqryStatus)">设置标签</a>
                        <a class="swb-btn-link" v-if="checkActionPerm('sourceMgmt')" @click="showSourceTraceDlg(priceInqryVoucher)">来源管理</a>
                        <a class="swb-btn-link" v-if="checkActionPerm('cancelRelate') && priceInqryVoucher.srcFlag > 0" @click="cancelRelate(priceInqryVoucher.id)">取消来源</a>
                    </td>
                </tr>
                </tbody>
            </table>

            <table class="custom-tbl" v-if="priceInqryStatus==0 || priceInqryStatus==1 || priceInqryStatus==2 || priceInqryStatus==4 || priceInqryStatus==6 || priceInqryStatus==7 || priceInqryStatus==8">
                <thead class="head">
                <tr class="row">
                    <th>询价单号</th>
                    <th width="">询价标题</th>
                    <th>被询价公司</th>
                    <th>询价类型</th>
                    <th>申请人</th>
                    <th>申请时间</th>
                    <th>询价日期</th>
                    <th width="100">截止时间</th>
                    <th width="120" style="text-align: right">报价总金额(元)</th>
                    <th>操作</th>
                </tr>
                </thead>
                <tbody class="body">
                <tr class="row" v-for="priceInqryVoucher in priceInqryList">
                    <td>
                        <a class="swb-btn-link" @click="toPriceInpryInfo(priceInqryVoucher.id)">{{priceInqryVoucher.no}}</a>
                    </td>
                    <td style="text-align: left">{{priceInqryVoucher.title}}</td>
                    <td>{{priceInqryVoucher.peerMerchantName}}</td>
                    <td>{{priceInqryVoucher.tradeTypeName}}</td>
                    <td>{{priceInqryVoucher.applicantName}}</td>
                    <td>{{priceInqryVoucher.applyTime}}</td>
                    <td>{{priceInqryVoucher.publishTime}}</td>
                    <td>{{priceInqryVoucher.expireDate}}</td>
                    <td style="text-align: right">{{priceInqryVoucher.totalReplyPrice == null ? "" : (priceInqryVoucher.totalReplyPrice).toFixed(2)}}</td>
                    <td style="text-align: left">
                        <div v-if="priceInqryStatus == 0"> <!-- 全部-->
                            <a class="swb-btn-link" v-if="checkActionPerm('view')" @click="toPriceInpryInfo(priceInqryVoucher.id)">查看</a>
                            <a v-if="checkActionPerm('apply') && priceInqryVoucher.auditState == 1 && priceInqryVoucher.applyState == 1" class="swb-btn-link" @click="priceInpryApply(priceInqryVoucher.id)">提交申请</a>
                            <a v-if="checkActionPerm('audit') && postId == priceInqryVoucher.auditorPostId && priceInqryVoucher.auditState != 1 && priceInqryVoucher.applyState == 1" class="swb-btn-link" @click="priceInpryAudit(priceInqryVoucher.id)">审核</a>
                            <a v-if="checkActionPerm('publish') && !priceInqryVoucher.published && priceInqryVoucher.auditState == 1" class="swb-btn-link" @click="priceInpryPublish(priceInqryVoucher.id)">发布</a>
                            <a v-if="checkActionPerm('view_reply') && priceInqryVoucher.published == true" class="swb-btn-link" @click="toPriceReplyList(priceInqryVoucher.id,priceInqryVoucher.expireDate)">查看报价</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('setTag')" @click="setPriceInqryVoucherTag(priceInqryVoucher,priceInqryStatus)">设置标签</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('close') && priceInqryVoucher.finished" @click="priceInpryClose(priceInqryVoucher.id)">关闭</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('sourceMgmt')" @click="showSourceTraceDlg(priceInqryVoucher)">来源管理</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('cancelRelate') && priceInqryVoucher.srcFlag > 0" @click="cancelRelate(priceInqryVoucher.id)">取消来源</a>
                        </div>
                        <div v-if="priceInqryStatus == 1"> <!-- 待申请-->
                            <a class="swb-btn-link" v-if="checkActionPerm('view')" @click="toPriceInpryInfo(priceInqryVoucher.id)">查看</a>
                            <a v-if="checkActionPerm('apply') && priceInqryVoucher.auditState != 1 && priceInqryVoucher.applyState != 1" class="swb-btn-link" @click="priceInpryApply(priceInqryVoucher.id)">提交申请</a>
                            <a v-if="checkActionPerm('delete') && !priceInqryVoucher.published" class="swb-btn-link" @click="priceInpryDelete(priceInqryVoucher.id)">删除</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('setTag')" @click="setPriceInqryVoucherTag(priceInqryVoucher,priceInqryStatus)">设置标签</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('sourceMgmt')" @click="showSourceTraceDlg(priceInqryVoucher)">来源管理</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('cancelRelate') && priceInqryVoucher.srcFlag > 0" @click="cancelRelate(priceInqryVoucher.id)">取消来源</a>
                        </div>
                        <div v-if="priceInqryStatus == 2"> <!-- 待审核 -->
                            <a v-if="checkActionPerm('audit') && postId == priceInqryVoucher.auditorPostId && priceInqryVoucher.auditState != 1 && priceInqryVoucher.applyState == 1"" class="swb-btn-link" @click="priceInpryAudit(priceInqryVoucher.id)">审核</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('view')" @click="toPriceInpryInfo(priceInqryVoucher.id)">查看</a>
                            <!--<a v-if="checkActionPerm('delete') &&  !priceInqryVoucher.published" class="swb-btn-link" @click="priceInpryDelete(priceInqryVoucher.id)">删除</a>-->
                            <a class="swb-btn-link" v-if="checkActionPerm('setTag')" @click="setPriceInqryVoucherTag(priceInqryVoucher,priceInqryStatus)">设置标签</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('sourceMgmt')" @click="showSourceTraceDlg(priceInqryVoucher)">来源管理</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('cancelRelate') && priceInqryVoucher.srcFlag > 0" @click="cancelRelate(priceInqryVoucher.id)">取消来源</a>
                        </div>
                        <!--<div v-if="priceInqryStatus == 3"> &lt;!&ndash; 审核未通过 &ndash;&gt;-->
                        <!--<a v-if="userInfo.userId != priceInqryVoucher.creatorId && priceInqryVoucher.auditState ==0" class="swb-btn-link" @click="priceInpryAudit(priceInqryVoucher.id)">审核</a>-->
                        <!--<a class="swb-btn-link" @click="toPriceInpryInfo(priceInqryVoucher.id)">查看</a>-->
                        <!--<a v-if="userInfo.userId == priceInqryVoucher.creatorId" class="swb-btn-link" @click="priceInpryDelete(priceInqryVoucher.id)">删除</a>-->
                        <!--<a class="swb-btn-link" @click="setPriceInqryVoucherTag(priceInqryVoucher,priceInqryStatus)">设置标签</a>-->
                        <!--<a class="swb-btn-link" @click="searchTag(priceInqryVoucher.tag)" type="text" size="small">搜索询价标签</a>-->
                        <!--<a class="swb-btn-link" @click="showSourceTraceDlg(priceInqryVoucher)">来源管理</a>-->
                        <!--</div>-->

                        <div v-if="priceInqryStatus == 4"> <!-- 待发布 -->
                            <a v-if="checkActionPerm('publish')" class="swb-btn-link" @click="priceInpryPublish(priceInqryVoucher.id)">发布</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('view')" @click="toPriceInpryInfo(priceInqryVoucher.id)">查看</a>
                            <a v-if="checkActionPerm('delete') &&  !priceInqryVoucher.published" class="swb-btn-link" @click="priceInpryDelete(priceInqryVoucher.id)">删除</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('setTag')" @click="setPriceInqryVoucherTag(priceInqryVoucher,priceInqryStatus)">设置标签</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('sourceMgmt')" @click="showSourceTraceDlg(priceInqryVoucher)">来源管理</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('cancelRelate') && priceInqryVoucher.srcFlag > 0" @click="cancelRelate(priceInqryVoucher.id)">取消来源</a>
                        </div>
                        <div v-if="priceInqryStatus == 6"> <!-- 已过期 -->
                            <a class="swb-btn-link" v-if="checkActionPerm('view')" @click="toPriceInpryInfo(priceInqryVoucher.id)">查看</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('setTag')" @click="setPriceInqryVoucherTag(priceInqryVoucher,priceInqryStatus)">设置标签</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('sourceMgmt')" @click="showSourceTraceDlg(priceInqryVoucher)">来源管理</a>
                            <!--<a  class="swb-btn-link" v-if="checkActionPerm('close')" @click="priceInpryClose(priceInqryVoucher.id)">关闭</a>-->
                            <a class="swb-btn-link" v-if="checkActionPerm('finish')" @click="priceInqryFinish(priceInqryVoucher.id)">结束</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('cancelRelate') && priceInqryVoucher.srcFlag > 0" @click="cancelRelate(priceInqryVoucher.id)">取消来源</a>
                        </div>
                        <div v-if="priceInqryStatus == 7"> <!-- 已结束 -->
                            <a class="swb-btn-link" v-if="checkActionPerm('view_reply')" @click="toPriceReplyList(priceInqryVoucher.id,priceInqryVoucher.expireDate,'finished')">查看报价</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('view')" @click="toPriceInpryInfo(priceInqryVoucher.id)">查看</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('setTag')" @click="setPriceInqryVoucherTag(priceInqryVoucher,priceInqryStatus)">设置标签</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('sourceMgmt')" @click="showSourceTraceDlg(priceInqryVoucher)">来源管理</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('close')" @click="priceInpryClose(priceInqryVoucher.id)">关闭</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('cancelRelate') && priceInqryVoucher.srcFlag > 0" @click="cancelRelate(priceInqryVoucher.id)">取消来源</a>
                        </div>
                        <div v-if="priceInqryStatus == 8"> <!-- 已关闭 -->
                            <a class="swb-btn-link" v-if="checkActionPerm('view')" @click="toPriceInpryInfo(priceInqryVoucher.id)">查看</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('setTag')" @click="setPriceInqryVoucherTag(priceInqryVoucher,priceInqryStatus)">设置标签</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('sourceMgmt')" @click="showSourceTraceDlg(priceInqryVoucher)">来源管理</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('cancelRelate') && priceInqryVoucher.srcFlag > 0" @click="cancelRelate(priceInqryVoucher.id)">取消来源</a>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>

        </div>
        <div class="pagination-layout mt10">
            <el-pagination background class="pagination-layout mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="prev, pager, next, jumper, sizes, total"></el-pagination>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import appConf from '../../app.conf';
    //
    import userApi from '../../api/user'
    import priceApi from '../../api/price'

    import { showComActionPostSelectDlg } from '../merchant/showSelectDlg'
    import { showBizAuditDlg } from '../merchant/showSelectDlg'
    import { getDefaultPageSizes } from '../../../src/app.conf'
    import { checkUserActionPerm } from '../index'

    import SwbPriceInpryAudit from './PriceInpryAudit';

    Vue.regist(SwbPriceInpryAudit);
    import SwbPriceApply from './PriceApply';

    Vue.regist(SwbPriceApply);

    import SwbPriceInpryInfo from './PriceInpryInfo';

    Routes.add(SwbPriceInpryInfo);
    import SwbPriceReplyList from './PriceReplyList';

    Routes.add(SwbPriceReplyList);
    import SwbDeviceRequireVoucherManager from '../retailer/DeviceRequireVoucherManager';

    Routes.add(SwbDeviceRequireVoucherManager);

    import SwbPriceInprySearch from './PriceInprySearch'

    Vue.regist(SwbPriceInprySearch);

    export default {
        name: 'swb-price-inpry-list',
        path: '/price/inpry/voucher/list',
        pathOld: '/price/inpry/list',
        avlActions: 'view_reply|view|setTag|searchTag|sourceMgmt|cancelRelate|audit|apply|delete|publish|close',
        avlActionNames: '关闭已过期、查看、设置标签、搜索询价标签、来源管理、提交申请、删除、关闭、审核、发布、查看报价、',
        avlScopes: 'retailer',
        desc: '询价单列表',
        helpArticleCode: 'retailer-price-inpry-voucher-list',
        data: function () {
            return {
                //
                pageNumber: 1,
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                priceInqryList: [],
                priceInqryStateList: [],
                priceInqryStatus: 0,
                userInfo: {
                    userId: null,
                },
                postId: null,
                type: null,
                no: null,
                //排序、搜索
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
            }
        },
        created: function () {
            let self = this;
            //保持pageSize的一致性
            this.pageSize = this.pageSizes.first();
            //----------------------分页--------------------------------

            let no = this.$route.query.no || null;
            if(!Utils.isNoB(no)) {
                this.no = no
                this.queryModel.filterItems.no = no;
            }
            //----------------------查询------------------------------

            self.userCurrentInfo();
            let checkState = this.$route.query.checkState || null;
            if(checkState != null) {
                self.getPriceInpryList(checkState);
            } else {
                self.getPriceInpryList(0);
            }
            // 过滤条件 枚举
            self.priceInqryStateList = getEnumMap('priceInqryState', 'value2text');
        },
        methods: {
            priceInqrySearch: function (data) {
                this.queryModel = data;
                this.pageNumber = 1;
                this.getPriceInpryList(this.priceInqryStatus);
            },
            checkActionPerm: function (action, targetPostId) {
                return checkUserActionPerm(Vue.$getClassInfo(this).path, action, targetPostId);
            },
            // 页签切换
            tabChange: function (val) {
                this.pageNumber = 1;
                this.getPriceInpryList(val);
            },
            handleSizeChange: function (val) {
                this.pageSize = val;
                this.handlePageChange(1);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getPriceInpryList(this.priceInqryStatus);
            },

            searchTag: function (tag) {
                this.tag = tag;
                this.searchShow = true;
                this.getPriceInpryList(this.priceInqryStatus);
            },
            showSearch: function (flag) {
                this.searchShow = flag;
            },

            userCurrentInfo: function () {   // 当前登录信息
                let self = this;
                let data = {};
                userApi.getUserInfoByContext(data, function (result) {
                    if(result.type === "info") {
                        let userInfo = result.data;
                        self.postId = userInfo.scopeEntity.postId;
                        self.userInfo = userInfo;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },

            //获取列表信息
            getPriceInpryList: function (value) {
                let self = this;
                self.priceInqryStatus = value;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                if(value == null) {
                    value = self.priceInqryStatus;
                }
                filterItems.priceInqryStatus = value;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let lastMsgBoxDlg = MsgBox.loading();
                priceApi.getPriceInqryVoucherList(postData, function (result) {
                    lastMsgBoxDlg.close();
                    if(result.type == 'info') {
                        let priceInqryList = result.data.rows;
                        for(let i = 0; i < priceInqryList.length; i++) {
                            let priceInqry = priceInqryList[i];
                            priceInqry.tradeTypeName = getEnumInfoWith('tradeType', 'value', priceInqry.tradeType).text.substring(0, 2);
                        }
                        self.priceInqryList = priceInqryList;
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },

            // 申请
            priceInpryApply: function (id) {
                let self = this;

                showComActionPostSelectDlg({
                    rescUrl: Vue.$getClassInfo(this).path,
                    action: 'audit',
                }, function (resultData) {
                    resultData = resultData || {};
                    if(resultData.postId == null) {
                        Toast.show('请选 择审核岗位', 3000, 'warning');
                        return false;
                    }
                    //
                    let postData = {
                        id: id,
                        //
                        auditorPostId: resultData.postId,
                        auditorPostName: resultData.actionPostName,
                        //
                        applyDesc: resultData.applyDesc
                    };
                    //
                    priceApi.applyPriceInqryVoucher(postData, function (result) {
                        if(result.type == 'info') {
                            MsgBox.success('申请成功，等待审核');
                            self.getPriceInpryList(self.priceInqryStatus);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });

                }, this);
            },
            // 审核
            priceInpryAudit: function (id) {
                let self = this;

                showBizAuditDlg({
                    title: "询价 - 审核",
                    nextPostParams: {
                        rescUrl: Vue.$getClassInfo(this).path,
                        action: 'audit',
                    }
                }, function (resultData) {
                    resultData = resultData || {};
                    let nextPostResultData = resultData.nextPostResultData || null;
                    let auditorPostId = null;
                    if(nextPostResultData != null) {
                        auditorPostId = nextPostResultData.postId;
                    }
                    let postData = {
                        id: id,
                        auditState: resultData.auditState,
                        auditDesc: resultData.auditDesc,
                        auditorPostId: auditorPostId,
                    };
                    priceApi.auditPriceInqryVoucher(postData, function (result) {
                        if(result.type == 'info') {
                            MsgBox.success('操作成功');
                            self.getPriceInpryList(self.priceInqryStatus);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }, this);
            },

            // 发布
            priceInpryPublish: function (id) {
                let self = this;
                this.$confirm('是否确定发布 ?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    priceApi.publishPriceInqryVoucher(id, function (result) {
                        if(result.type == 'info') {
                            MsgBox.success('发布成功，静等报价……');
                            self.getPriceInpryList(self.priceInqryStatus);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {

                });
            },

            // 关闭询价
            priceInpryClose: function (id) {
                let self = this;
                this.$confirm('是否确定关闭 ?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    priceApi.closePriceInqryVoucher(id, function (result) {
                        if(result.type == 'info') {
                            MsgBox.success('关闭成功');
                            self.getPriceInpryList(self.priceInqryStatus);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {

                });
            },

            // 关闭询价
            closeOverduePriceInpry: function () {
                let self = this;
                this.$confirm('是否确定关闭全部过期询价 ?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    priceApi.closePriceInqryVoucherExpired(function (result) {
                        if(result.type == 'info') {
                            MsgBox.success('关闭成功');
                            self.getPriceInpryList(self.priceInqryStatus);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {

                });
            },

            // 删除询价
            priceInpryDelete: function (id) {
                let self = this;
                this.$confirm('是否确定删除 ?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    priceApi.deletePriceInqryVoucher(id, function (result) {
                        if(result.type == 'info') {
                            MsgBox.success('删除成功');
                            self.getPriceInpryList(self.priceInqryStatus);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {

                });
            },

            // 查看详情
            toPriceInpryInfo: function (id, expireDate) {
                this.$router.push({
                    path: SwbPriceInpryInfo.path,
                    query: {
                        id: id,
                        checkState: this.priceInqryStatus
                    }
                });
            },

            // 查看报价列表
            toPriceReplyList: function (id, expireDate, finished) {
                this.$router.push({
                    path: SwbPriceReplyList.path,
                    query: {
                        id: id,
                        expireTime: expireDate,
                        checkState: this.priceInqryStatus,
                        finished: finished
                    }
                });
            },

            setPriceInqryVoucherTag: function (row, value) {
                let self = this;
                Vue.$showDialog({
                    title: '设置标签',
                    showCloseBtn: true,
                    width: 530,
                    height: 300,
                    template: '<div class="simple-form">' +
                    '<div class="form-group center">' +
                    '<div class="form-label">' +
                    '<label>标签</label>' +
                    '</div>' +
                    '<div class="form-value width-1-5x">' +
                    '<el-input type="text" v-model="tag"></el-input>' +
                    '</div>' +
                    '</div>' +
                    '</div>',
                    data: {
                        tag: row.tag
                    },
                    methods: {},
                    okClicked: function () {
                        let selfDlg = this;
                        row.tag = selfDlg.tag;
                        priceApi.updatePriceInqryVoucherToDelete(row, function (result) {
                            if(result.type === "info") {
                                MsgBox.success('设置成功!');
                            } else {
                                MsgBox.warning(result.message);
                            }
                        })
                    },
                    lifecycle: {}
                });
            },
            showSourceTraceDlg: function (row) {
                let self = this;
                Vue.$showDialog({
                    title: '跟踪信息',
                    showCloseBtn: true,
                    height: 600,
                    template: '<div>' +
                    '<swb-device-require-voucher-for-select :srcId = "srcId" :toDeviceRequireVoucherList="toDeviceRequireVoucherList" ref="swb_device_require_voucher_for_select"></swb-device-require-voucher-for-select>' +
                    '</div>',
                    data: {
                        srcId: row.srcId,
                        showSelect: false
                    },
                    methods: {
                        toDeviceRequireVoucherList: function (no) {
                            self.toDeviceRequireVoucherList(no);
                        },
                    },
                    okClicked: function () {
                        let selfDlg = this;
                        let result = selfDlg.$refs.swb_device_require_voucher_for_select.getDlgResult() || {};
                        if(result.type == "info") {
                            row.srcId = result.data.srcId;
                            row.srcFlag = result.data.srcFlag;
                            priceApi.updatePriceInqryVoucher(row, function (result) {
                                if(result.type === "info") {
                                    MsgBox.success('设置成功');
                                    self.getPriceInpryList(self.priceInqryStatus);
                                }
                            });
                        } else {
                            MsgBox.warning(result.message);
                            return false;
                        }
                    },
                    lifecycle: {
                        created: function () {
                            let selfDlg = this;
                            selfDlg.showSelect = true;
                        }
                    }
                });
            },
            cancelRelate: function (id) {
                let self = this;
                this.$confirm('是否确定取消此来源 ?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postParam = {};
                    postParam.id = id;
                    priceApi.cancelPriceInqryVoucherSrc(postParam, function (result) {
                        if(result.type == 'info') {
                            MsgBox.success('取消成功');
                            self.getPriceInpryList(self.priceInqryStatus);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {

                });
            },
            toDeviceRequireVoucherList: function (no) {
                let data = {no: no};
                let hashUrl = Utils.makeUrl(SwbDeviceRequireVoucherManager.path, data);
                appConf.openPageRouteUrl(null, "/bench/home", hashUrl);
            },
            priceInqryFinish: function (id) {
                let self = this;
                this.$confirm('是否确定结束 ?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let theLoad = MsgBox.loading();
                    priceApi.finishPriceInqryVoucher(id, function (result) {
                        theLoad.close();
                        if(result.type == 'info') {
                            MsgBox.success('操作成功');
                            self.getPriceInpryList(self.priceInqryStatus);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {

                });
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/priceInpry/PriceInpryList.vue